import { render, staticRenderFns } from "./AlertsMessagesListItemComponent.vue?vue&type=template&id=73c0aa26&scoped=true"
import script from "./AlertsMessagesListItemComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertsMessagesListItemComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AlertsMessagesListItemComponent.vue?vue&type=style&index=0&id=73c0aa26&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0aa26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c0aa26')) {
      api.createRecord('73c0aa26', component.options)
    } else {
      api.reload('73c0aa26', component.options)
    }
    module.hot.accept("./AlertsMessagesListItemComponent.vue?vue&type=template&id=73c0aa26&scoped=true", function () {
      api.rerender('73c0aa26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AlertsMessages/AlertsMessagesListItemComponent.vue"
export default component.exports